import { Card, CardBody, CardHeader } from '@execonline-inc/execonline-ui';
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import ExperienceFooter from '../../../../../ExperienceFooter';
import { ExperienceResource } from '../../../../../Types';
import ExperienceBody from '../ExperienceBody';
import ListProgramExperienceCardVideo from './ListProgramExperienceCardVideo';
import UnlicensedBadge from '../../../../../LicenseTracker/UnlicensedBadge';

export interface Props {
  experienceResource: ExperienceResource;
  sectionIndex: number;
  selectedDateIds?: Set<number>;
  onEditDates?: () => void;
}

function ProgramExperienceCard({
  experienceResource,
  sectionIndex,
  selectedDateIds,
  onEditDates,
}: Props) {
  return (
    <div tabIndex={-1} className="flex w-full relative group">
      <UnlicensedBadge
        productLicenseTypeIds={experienceResource.payload.product_license_type_ids}
        experienceId={just(experienceResource.payload.id)}
        licenseStartsOn={experienceResource.payload.license_starts_on}
      />
      <Card
        tabIndex={0}
        data-intercom-target="experience-card"
        className="min-h-46 w-full bg-card border border-border rounded-lg md:flex-col lg:flex-row hover:border-primary hover:shadow-lg transition-all"
        radius="none"
      >
        <CardHeader className="items-start p-0 shadow-none lg:py-6 lg:pl-6 lg:pr-2">
          <ListProgramExperienceCardVideo
            experienceResource={experienceResource}
            className="flex h-[11.625rem] w-full lg:h-35 lg:w-[15.5rem] lg:rounded-md"
          />
        </CardHeader>
        <CardBody className="gap-10 px-4 pb-3 pt-4 lg:gap-5 lg:p-6 lg:pl-2">
          <ExperienceBody
            experienceResource={experienceResource}
            selectedDateIds={selectedDateIds}
            onEditDates={onEditDates}
          />
          <ExperienceFooter experienceResource={experienceResource} />
        </CardBody>
      </Card>
    </div>
  );
}

export default observer(ProgramExperienceCard);
